export const dataDelete = (data) => {
	return {
		reason: 'Falta de stock',
		items: [
			{
				code_internal: data?.code_internal,
				price: data?.unit_price,
				quantity: 0,
			},
		],
	};
};
